import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";

const NotFound = () => (
  <div className="min-h-[75vh] flex items-center bg-[#1A3D84]">
    <Seo title="Page Not Found" description="The page you were looking for could not be found." path="/404" noindex />
    <div className="container-custom text-center">
      <p className="font-display text-7xl sm:text-8xl text-[#CD1422] font-semibold mb-4">404</p>
      <h1 className="text-3xl sm:text-4xl text-white mb-4">Page Not Found</h1>
      <p className="text-white/70 max-w-md mx-auto mb-9">
        The page you were looking for doesn't exist or has moved. Let's get you back on track.
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link to="/" className="btn btn-primary"><Home size={17} /> Back Home</Link>
        <Link to="/contact" className="btn btn-outline-light">Get a Free Estimate <ArrowRight size={16} /></Link>
      </div>
    </div>
  </div>
);

export default NotFound;
